"use strict";

var _slicedToArray = require("/codebuild/output/src253626114/src/mrt-covid19-center/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/* eslint-disable @typescript-eslint/no-unsafe-assignment */

/** @jsxImportSource @emotion/react */


var react_1 = require("react");

var react_id_generator_1 = tslib_1.__importDefault(require("react-id-generator"));

var styles = tslib_1.__importStar(require("./InteractiveRatingStar.style"));

var Star_1 = tslib_1.__importDefault(require("./Star"));

var reviewTextList = ['완전 별로에요', '별로예요', '보통이에요', '좋아요', '최고예요!'];
var MAX_REVIEW_STARS = 5;

function InteractiveRatingStar(_ref) {
  var className = _ref.className,
      title = _ref.title,
      onChange = _ref.onChange,
      _ref$defaultRating = _ref.defaultRating,
      defaultRating = _ref$defaultRating === void 0 ? 0 : _ref$defaultRating;
  var deafultFillList = react_1.useMemo(function () {
    return Array(MAX_REVIEW_STARS).fill({
      isFill: false,
      isHover: false
    }).map(function (_, index) {
      return {
        isFill: defaultRating > index,
        isHover: false
      };
    });
  }, [defaultRating]);

  var _react_1$useState = react_1.useState(deafultFillList),
      _react_1$useState2 = _slicedToArray(_react_1$useState, 2),
      fillList = _react_1$useState2[0],
      setFillList = _react_1$useState2[1];

  var _react_1$useState3 = react_1.useState(defaultRating - 1 || -1),
      _react_1$useState4 = _slicedToArray(_react_1$useState3, 2),
      selected = _react_1$useState4[0],
      setSelected = _react_1$useState4[1];

  var _react_1$useState5 = react_1.useState(defaultRating - 1 || -1),
      _react_1$useState6 = _slicedToArray(_react_1$useState5, 2),
      reviewTextIndex = _react_1$useState6[0],
      setReviewTextIndex = _react_1$useState6[1];

  function handleOver(_ref2) {
    var target = _ref2.target;
    var eventTarget = target;
    var selectedIndex = eventTarget.getAttribute('data-index');

    if (selectedIndex === null) {
      return;
    }

    var selectedIndexNumber = parseInt(selectedIndex, 10);

    if (reviewTextIndex === selectedIndexNumber) {
      return;
    }

    var draftFillList = fillList.map(function (_ref3, index) {
      var isFill = _ref3.isFill;
      return {
        isFill: isFill,
        isHover: selectedIndexNumber >= index
      };
    });
    setFillList(draftFillList);
    setReviewTextIndex(selectedIndexNumber);
  }

  function handleClick(_ref4) {
    var target = _ref4.target;
    var eventTarget = target;
    var selectedIndex = eventTarget.getAttribute('data-index');

    if (selectedIndex === null) {
      return;
    }

    var selectedIndexNumber = parseInt(selectedIndex, 10);

    if (selected === selectedIndexNumber) {
      return;
    }

    var draftFillList = fillList.map(function (_, index) {
      return {
        isFill: selectedIndexNumber >= index,
        isHover: false
      };
    });
    setFillList(draftFillList);
    setSelected(selectedIndexNumber);
    setReviewTextIndex(selectedIndexNumber);
    onChange && onChange(selectedIndexNumber + 1);
  }

  function handleMouseLeave() {
    if (selected === -1) {
      setFillList(Array(MAX_REVIEW_STARS).fill({
        isFill: false,
        isHover: false
      }));
      setReviewTextIndex(-1);
      return;
    }

    setFillList(fillList.map(function (_ref5) {
      var isFill = _ref5.isFill;
      return {
        isFill: isFill,
        isHover: false
      };
    }));
    setReviewTextIndex(selected);
  }

  return jsx_runtime_1.jsxs("div", Object.assign({
    className: className
  }, {
    children: [title && jsx_runtime_1.jsx("div", Object.assign({
      css: styles.title
    }, {
      children: title
    }), void 0), jsx_runtime_1.jsxs("div", Object.assign({
      css: styles.stars,
      onMouseMove: handleOver,
      onClick: handleClick,
      onMouseLeave: handleMouseLeave
    }, {
      children: [fillList.map(function (_ref6, index) {
        var isFill = _ref6.isFill,
            isHover = _ref6.isHover;
        return jsx_runtime_1.jsx(Star_1.default, {
          index: index,
          isFill: isFill,
          isHover: isHover
        }, react_id_generator_1.default());
      }), reviewTextIndex !== -1 && jsx_runtime_1.jsx("span", Object.assign({
        css: styles.reviewText
      }, {
        children: reviewTextList[reviewTextIndex]
      }), void 0)]
    }), void 0)]
  }), void 0);
}

exports.default = InteractiveRatingStar;